/**
 * Simple setState closure that also runs the value through a function before
 * flushing it to state.
 *
 * It receives a setState function returned by React.useState()
 *
 * When to use it?
 * When you have a simple change of state and you need to transform the data before it goes into state
 *
 * Why to use it?
 * It will help you with annoying code coverage where you are
 * doing a simple setState: forget istanbul statements
 *
 * @example
 * const [name, setName] = React.useState("");
 * <Input id="name" value={name} onChange={setAndCastState(setName, Number)} />
 */
export function setAndCastState<T, CastValue>(
  setState: (value: CastValue) => void,
  castFunction: (value: T) => CastValue
) {
  return (value: T) => {
    setState(castFunction(value));
  };
}
